<template>
  <header
    id="sf-header"
    :style="{ height: `${height}px` }">
    <div
      ref="container"
      :class="{ fixed, active }"
      :style="{ top: `-${height}px`, ...style }"
      class="container">
      <slot/>
    </div>
  </header>
</template>

<script>
import throttle from 'lodash/throttle';

export default {
  props: {
    activeBackground: {
      type: String,
      default: '#fff',
    },
  },
  data: () => ({
    lastScrollPosition: 0,
    height: null,
    fixed: false,
    active: false,
  }),
  computed: {
    style() {
      if (this.fixed) {
        return {
          'background-color': this.activeBackground,
        };
      }

      return {};
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.height = Math.max(this.$refs.container.scrollHeight, 0);
    },
    onScroll: throttle(function() {
      this.fixed = window.scrollY > this.height;
      this.active = this.fixed && window.scrollY < this.lastScrollPosition;
      this.$ui.headerActive = this.active;
      this.lastScrollPosition = window.scrollY;
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.container {
  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    transition: transform 0.6s ease-in-out;

    &.active {
      transform: translateY(100%);
    }
  }
}
</style>
